const buttonSaveText = 'Сохранить и продолжить';
const buttonSaveProgressText = 'Сохраняем...';

function setSaveButtonActive(button) {
  button.disabled = false;
  button.classList.remove('opacity-50');
  const buttonText = button.querySelector('span');
  buttonText.textContent = buttonSaveText;
  if (typeof window.__hideWbStepLoader === 'function') {
    window.__hideWbStepLoader();
  }
}

function setSaveButtonDisabled(button) {
  button.disabled = true;
  button.classList.add('opacity-50');
  const buttonText = button.querySelector('span');
  buttonText.textContent = buttonSaveProgressText;
}

export { setSaveButtonActive, setSaveButtonDisabled }